import { Timestamp } from '@firebase/firestore-types';
import { UserProfile } from '../profiles/profile.model';

export namespace Comments {
  export enum IndexField {
    CREATED_AT = 'createdAt',
    PUBLISHED_AT = 'publishedAt',
  }

  export enum Type {
    ANNIVERSARIES = 'anniversaries',
    MESSAGE = 'message',
    WELCOME = 'welcome',
  }

}
export class Comment {
  id?: string;
  type: Comments.Type;
  createdAt: Timestamp;
  modifiedAt: Timestamp;
  organizationId: string;
  publishedAt: string;
  constructor(type: Comments.Type) {
    this.type = type;
    this.publishedAt = new Date().toISOString();
  }
}

export class Anniversaries extends Comment {
  picture: string;
  anniversaries: Array<UserProfile>;
  imageUrl: string;
  constructor() {
    super(Comments.Type.ANNIVERSARIES);
  }
}

export class Message extends Comment {
  description: string;
  author: UserProfile;
  imageUrl: string;
  constructor() {
    super(Comments.Type.MESSAGE);
  }
}

export class Welcome extends Comment {
  picture: string;
  newcomer: UserProfile;
  imageUrl: string;
  constructor() {
    super(Comments.Type.WELCOME);
  }
}
